export default __webpack_public_path__ + "static/media/Theme7.5566fd32.jpg";